import type {
  DocumentSchema,
  SearchResponse,
  SearchResponseHit,
} from 'typesense/lib/Typesense/Documents';
import { intersperseAssets } from './intersperse-assets';

/**
 * Shared utility to process search results from infinite queries.
 * This function handles both free and premium track combinations with proper interspersing.
 *
 * @param searchResults - Array of search results from the infinite query
 * @param fetchFreeAndPremium - Whether to fetch both free and premium tracks
 * @returns Combined array of hits from all search results
 */
export const processSearchResults = <T extends DocumentSchema>(
  searchResults: SearchResponse<T>[],
  fetchFreeAndPremium: boolean
): SearchResponseHit<T>[] => {
  // If we're fetching both free and premium and have exactly 2 result sets, intersperse them
  if (
    fetchFreeAndPremium &&
    searchResults.length === 2 &&
    searchResults[0]?.hits &&
    searchResults[1]?.hits
  ) {
    return intersperseAssets({
      premiumAssetSearchResults: searchResults[0],
      freeAssetSearchResults: searchResults[1],
    });
  }

  // Otherwise return the hits from the first result
  return searchResults[0]?.hits || [];
};
